import API from "../Common/Endpoint/serviceConstrants";
import axiosInstance from "../Common/Axios/axiosInstance";

export const callCreateCategoryAllGetApi = async () => {
  const clientId =
    typeof sessionStorage !== "undefined"
      ? sessionStorage.getItem("clientCode")
      : "";

  try {
    const { data = [] } = await axiosInstance.get(API.activeCategories);
    if (data?.httpStatusCode === "200" || data?.responseCode === "200") {
      return data;
    }
  } catch (error) {
    // Fall through to compatibility API below.
  }

  const { data = [] } = await axiosInstance.get(
    `/client-category/by-client/${clientId}`
  );
  return data;
};
